<template lang="pug">
  TabWrapper.elevation-2(type="systemSettings")
    div
      Header(
        mini-button,
        icon="plus",
        color="success",
      )
         template(v-slot:filters="")
          v-col(fluid)
            v-spacer
          v-col(sm=4)
            div.action-wrapper
              FilterBox.mr-2(
                :label="$t('table.mediaTag.filter')",
                :search.sync="search",
                @update:search="fetch({ hardFetch: true })",
              )
              v-btn.ml-1(
                fab,
                small,
                depressed,
                v-if="isSuperadmin",
                color="primary",
                @click="exportData",
              )
                v-icon fas fa-file-download

              v-btn.ml-1(
                fab,
                small,
                depressed,
                color="primary",
                @click="showForm({})",
              )
                v-icon fas fa-plus

      TableWrapper(
        loading-text="Loading... Please wait",
        ref="table",
        type="mediaTag",
        :items="items",
        :loading="isLoading",
        :misc="misc",
        @sort="fetch",
      )
        template(v-slot:default="{ item, headers, misc }")
          RowWrapper(
            hide-hover,
            :is-loading="isLoading",
            :item="item",
            :headers="headers",
            :misc="misc",
            confirmation-key="name",
            type="mediaTag",
            @selected="showForm(item)",
            @deleted="fetch({})",
            @toggle="toggle",
          )

      Pagination.pb-2(
        :pagination="pagination",
        @changePage="fetch",
      )

      DynamicSystemSettingModal(
        v-if="dialog",
        type="mediaTag",
        :dialog="dialog",
        :item="activeOption",
        @close="dialog = false",
      )

</template>

<script>
import { mapGetters } from 'vuex';
import { mergeRight } from 'ramda';
import { progressWrapper, roleManager, tableHelper } from '@/config/mixins.js';

import DynamicSystemSettingModal from '@/components/forms/DynamicSystemSettingModal.vue';
import FilterBox from '@/components/table/FilterBox.vue';
import Header from '@/components/forms/Header.vue';
import Pagination from '@/components/table/Pagination.vue';
import RowWrapper from '@/components/wrapper/RowWrapper.vue';
import TableWrapper from '@/components/wrapper/TableWrapper.vue';
import TabWrapper from '@/components/wrapper/TabWrapper.vue';

export default {
  components: {
    DynamicSystemSettingModal,
    FilterBox,
    Header,
    Pagination,
    RowWrapper,
    TableWrapper,
    TabWrapper,
  },

  mixins: [progressWrapper, roleManager, tableHelper],

  data() {
    return {
      activeOption: {},
      dialog: false,
      search: null,
      misc: {
        sortBy: 'name',
        sortDesc: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      items: 'mediaTag/items',
      pagination: 'mediaTag/pagination',
    }),
  },

  methods: {
    prepareFetchPayload() {
      return {
        type: 'mediaTag',
        params: {
          search: this.search,
          hardFetch: true,
        },
      };
    },

    showForm(item) {
      this.dialog = true;
      this.activeOption = item;
    },

    toggle({ id, value: is_deactivated }) {
      const action = is_deactivated ? 'reactivate' : 'remove';

      this.wrapProgress(() => {
        this.$store.dispatch(`mediaTag/${action}`, id);
      });
    },

    exportData() {
      this.exportCSV({
        type: 'mediaTag',
        fileName: 'mediaTags.csv',
        params: mergeRight(this.$refs.table.misc, { search: this.search }),
      });
    },
  },
};
</script>
